import { EventLogs } from "@/components/features/matter/event-logs/EventLogs";
import MatterOverview from "@/components/features/matter/overview/MatterOverview";
import { Card, CardHeader, Typography } from "@/components/ui";
import { retrieveMatterQueryOptions } from "@/lib/data/react-query/matters/matter";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/matters/$matterId/_layout/")({
  validateSearch: (
    search: Record<string, unknown>,
  ): { phaseActionId?: string } => ({
    phaseActionId:
      typeof search.phaseActionId === "string" &&
      /^[^#:]+$/.test(search.phaseActionId)
        ? search.phaseActionId
        : undefined,
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const { matterId } = Route.useParams();
  const { data: matterDetails } = useSuspenseQuery(
    retrieveMatterQueryOptions(matterId),
  );

  const matterData = matterDetails.data;
  const isMatterPayload = !Array.isArray(matterData) && Boolean(matterData.id);
  const resolvedMatterId = Array.isArray(matterData) ? matterId : matterData.id;

  if (!isMatterPayload) {
    return <MatterDeletedEventLogView matterId={resolvedMatterId} />;
  }

  return <MatterOverview matter={matterData} />;
}

const MatterDeletedEventLogView = ({ matterId }: { matterId?: string }) => {
  return (
    <div className="flex min-h-screen w-full flex-col gap-4 p-4 sm:p-6">
      <Card className="border-amber-200 bg-amber-50">
        <CardHeader className="space-y-1">
          <Typography variant="subHeading">This matter was deleted</Typography>
          <Typography className="text-muted-foreground text-sm">
            The matter no longer exists, but its event log is still available.
          </Typography>
        </CardHeader>
      </Card>
      <div className="min-h-0 flex-1">
        <EventLogs
          matter={{
            matterId,
          }}
        />
      </div>
    </div>
  );
};
